var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import isEmpty from "lodash/isEmpty";
import { ERentioFormField } from "../../components/components/Form";
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EBanqupRentioDocumentType, EField, } from "./schema.createRentDeposit.types";
import { getForeigners, getIsProviderBanqup, getNavigationTitle, getOwners, getTenants, } from "./schema.createRentDeposit.utils";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b, _c, _d, _e;
        var providerIsBanqup = getIsProviderBanqup(defaultValues[EField.Provider]);
        return {
            required: [EField.IdentityDocuments],
            properties: (_a = {},
                _a[EField.Header + "5"] = {
                    default: undefined,
                },
                _a[EField.IdentityDocuments] = {
                    default: (function () {
                        var _a;
                        var _b;
                        var value = getValue(EField.IdentityDocuments, initialValues, defaultValues);
                        if (!value || isEmpty(value)) {
                            var owners = getOwners(defaultValues, extraData);
                            var tenants = getTenants(defaultValues, extraData);
                            var payer_1 = tenants.length > 1
                                ? defaultValues[EField.Payer]
                                : [(_b = tenants[0]) === null || _b === void 0 ? void 0 : _b.id];
                            if (providerIsBanqup && payer_1 && tenants) {
                                var selectedPayer = (tenants || []).find(function (tenant) { return (tenant === null || tenant === void 0 ? void 0 : tenant.id) === payer_1[0]; });
                                var foreigners_1 = getForeigners(owners.map(function (owner) { return owner.id; }));
                                var docs_1 = [
                                    (_a = {},
                                        _a[EField.IdentityDocumentAccountId] = selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.id,
                                        _a.contact = selectedPayer,
                                        _a),
                                ];
                                if (foreigners_1 && foreigners_1.length > 0) {
                                    (foreigners_1 || []).forEach(function (contact) {
                                        var _a;
                                        docs_1.push((_a = {},
                                            _a[EField.IdentityDocumentAccountId] = contact.accountId,
                                            _a.contact = contact,
                                            _a));
                                    });
                                }
                                return docs_1;
                            }
                            var foreigners = getForeigners(getValue(EField.Signers, initialValues, defaultValues));
                            return (foreigners || []).map(function (contact) {
                                var _a;
                                return (_a = {},
                                    _a[EField.IdentityDocumentAccountId] = contact.accountId,
                                    _a.contact = contact,
                                    _a);
                            });
                        }
                        return value;
                    })(),
                    type: "array",
                    items: {
                        type: "object",
                        required: __spreadArray([
                            EField.IdentityDocumentIdentityFrontDocumentId,
                            EField.IdentityDocumentIdentityBackDocumentId
                        ], (providerIsBanqup ? [EField.DateOfExpiry] : []), true),
                        properties: __assign(__assign(__assign((_b = {}, _b[EField.IdentityDocumentAccountId] = {}, _b), (providerIsBanqup
                            ? (_c = {},
                                _c[EField.DocumentType] = {
                                    default: EBanqupRentioDocumentType.IdCard,
                                    // @ts-ignore
                                    options: [
                                        EBanqupRentioDocumentType.IdCard,
                                        EBanqupRentioDocumentType.Passport,
                                    ].map(function (id) { return ({
                                        id: id,
                                        value: getLocalizedText("rent_deposit.documentType.".concat(id.toLowerCase())),
                                    }); }),
                                },
                                _c) : {})), (_d = {}, _d[EField.IdentityDocumentIdentityFrontDocumentId] = {
                            minLength: 1,
                        }, _d[EField.IdentityDocumentIdentityBackDocumentId] = {
                            minLength: 1,
                        }, _d)), (providerIsBanqup
                            ? (_e = {},
                                _e[EField.DateOfExpiry] = {
                                    default: getValue(EField.DateOfExpiry, initialValues, defaultValues),
                                },
                                _e) : {})),
                    },
                    uniqueItems: true,
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a, _b;
    return _a = {
            "rentio:title": getLocalizedText("rent_deposit.identity_documents.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "5"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText(extraData.showProvider
                ? "rent_deposit.banqup_identity_documents.heading"
                : "rent_deposit.identity_documents.heading"),
        },
        _a[EField.IdentityDocuments] = {
            "ui:field": ERentioFormField.Array,
            title: getLocalizedText("rent_deposit.identity_documents.heading"),
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            getItemTitle: function (itemData) {
                return itemData.contact && getName(itemData.contact);
            },
            items: (_b = {},
                _b[EField.IdentityDocumentAccountId] = { "ui:widget": "hidden" },
                _b[EField.DocumentType] = {
                    "ui:field": ERentioFormField.SegmentedControl,
                    title: getLocalizedText("rent_deposit.documentType.label"),
                    formatSummary: function (formData) {
                        return getLocalizedText("rent_deposit.documentType.".concat(formData === null || formData === void 0 ? void 0 : formData.toLowerCase()));
                    },
                },
                _b[EField.IdentityDocumentIdentityFrontDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.front_document.label"),
                },
                _b[EField.IdentityDocumentIdentityBackDocumentId] = {
                    "ui:field": ERentioFormField.DocumentSelectInline,
                    formatSummary: function (formData) {
                        return formData === null || formData === void 0 ? void 0 : formData.map(function (doc) { return doc.name; }).join(", ");
                    },
                    accept: ["image/*"],
                    multiple: false,
                    title: getLocalizedText("rent_deposit.identity_documents.back_document.label"),
                },
                _b[EField.DateOfExpiry] = {
                    "ui:field": ERentioFormField.Date,
                    title: getLocalizedText("rent_deposit.id_expiry_date.label"),
                    formatSummary: function (input) { return input && formatDate(input); },
                },
                _b),
            formatSummary: function (input) {
                return input
                    .map(function (item) { return item.contact && getName(item.contact); })
                    .filter(Boolean)
                    .join(", ");
            },
        },
        _a;
};
